import { useTranslation } from 'react-i18next';
import ServiceLayout from './components/ServiceLayout';
import useSeoPage from '@/hooks/useSeoPage';

export default function SurgeryPage() {
  const { t } = useTranslation();
  const siteUrl = import.meta.env.VITE_SITE_URL ?? '';

  useSeoPage({
    title: 'Хирургическая стоматология Кишинёв | Удаление зубов | Zimbet32',
    description: 'Удаление зубов любой сложности, костная пластика и синус-лифтинг в Кишинёве. Zimbet32 — chirurgie stomatologică profesională în Chișinău.',
    keywords: 'удаление зубов Кишинёв, хирургическая стоматология, костная пластика, синус-лифтинг, chirurgie stomatologică Chișinău, Zimbet32',
    canonicalPath: '/services/surgery',
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'MedicalProcedure',
      name: 'Хирургическая стоматология',
      url: `${siteUrl}/services/surgery`,
      description: 'Хирургическая стоматология: удаление зубов любой сложности, костная пластика, синус-лифтинг, пластика десны в Кишинёве.',
      procedureType: 'https://schema.org/SurgicalProcedure',
      bodyLocation: 'Зубы, челюсть',
      provider: {
        '@type': 'Dentist',
        name: 'Zimbet32',
        url: siteUrl,
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Strada București 60',
          addressLocality: 'Chișinău',
          postalCode: 'MD-2012',
          addressCountry: 'MD',
        },
        telephone: '+373-22-22-07-09',
      },
    },
  });

  const procedures = [
    {
      icon: 'ri-scissors-cut-line',
      title: t('servicePages.surgery.procedure1'),
      description: t('servicePages.surgery.procedure1Desc')
    },
    {
      icon: 'ri-capsule-line',
      title: t('servicePages.surgery.procedure2'),
      description: t('servicePages.surgery.procedure2Desc')
    },
    {
      icon: 'ri-surgical-mask-line',
      title: t('servicePages.surgery.procedure3'),
      description: t('servicePages.surgery.procedure3Desc')
    },
    {
      icon: 'ri-syringe-line',
      title: t('servicePages.surgery.procedure4'),
      description: t('servicePages.surgery.procedure4Desc')
    },
    {
      icon: 'ri-heart-add-line',
      title: t('servicePages.surgery.procedure5'),
      description: t('servicePages.surgery.procedure5Desc')
    },
    {
      icon: 'ri-medicine-bottle-line',
      title: t('servicePages.surgery.procedure6'),
      description: t('servicePages.surgery.procedure6Desc')
    }
  ];

  const advantages = [
    {
      icon: 'ri-shield-cross-line',
      title: t('servicePages.surgery.benefit1'),
      description: t('servicePages.surgery.benefit1Desc')
    },
    {
      icon: 'ri-hand-heart-line',
      title: t('servicePages.surgery.benefit2'),
      description: t('servicePages.surgery.benefit2Desc')
    },
    {
      icon: 'ri-hospital-line',
      title: t('servicePages.surgery.benefit3'),
      description: t('servicePages.surgery.benefit3Desc')
    }
  ];

  const galleryImages = [
    'https://public.readdy.ai/ai/img_res/7efefe5e98883c94789cb6c9bacd4059.jpg',
    'https://readdy.ai/api/search-image?query=Dental%20tooth%20extraction%20procedure%2C%20professional%20oral%20surgeon%20with%20instruments%2C%20patient%20care%2C%20sterile%20surgical%20setting%2C%20modern%20dental%20clinic%2C%20precision%20medical%20work%2C%20professional%20healthcare%20environment%2C%20safety%20measures&width=800&height=600&seq=surgery-gallery-2&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Wisdom%20tooth%20removal%20surgery%20preparation%2C%20surgical%20instruments%20laid%20out%2C%20sterile%20field%20setup%2C%20professional%20dental%20surgery%20tools%2C%20modern%20medical%20equipment%2C%20organized%20workspace%2C%20clean%20clinical%20environment&width=800&height=600&seq=surgery-gallery-3&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Dental%20cyst%20removal%20surgical%20procedure%2C%20oral%20surgeon%20performing%20operation%2C%20advanced%20surgical%20microscope%2C%20precision%20instruments%2C%20sterile%20operating%20environment%2C%20professional%20medical%20team%2C%20modern%20dental%20surgery%20facility&width=800&height=600&seq=surgery-gallery-4&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Successful%20dental%20surgery%20recovery%20result%2C%20healed%20surgical%20site%2C%20professional%20post-operative%20care%2C%20patient%20satisfaction%2C%20modern%20dental%20clinic%2C%20quality%20surgical%20outcome%2C%20clean%20clinical%20setting&width=800&height=600&seq=surgery-gallery-5&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Dental%20surgeon%20consultation%20with%20patient%2C%20explaining%20procedure%2C%20modern%20clinic%20interior%2C%20professional%20healthcare%20communication%2C%20comfortable%20patient%20environment%2C%20trust%20and%20care%2C%20contemporary%20dental%20office&width=800&height=600&seq=surgery-gallery-6&orientation=landscape'
  ];

  return (
    <ServiceLayout
      heroImage="https://readdy.ai/api/search-image?query=Professional%20dental%20surgery%20operating%20room%2C%20modern%20surgical%20facility%20with%20advanced%20equipment%2C%20sterile%20environment%2C%20surgical%20lights%20and%20instruments%2C%20contemporary%20healthcare%20setting%2C%20clean%20organized%20medical%20workspace%2C%20professional%20oral%20surgery%20center&width=1920&height=600&seq=surgery-hero&orientation=landscape"
      breadcrumbKey="servicePages.surgery.title"
      titleKey="servicePages.surgery.title"
      descriptionKey="servicePages.surgery.description"
      procedures={procedures}
      advantages={advantages}
      galleryImages={galleryImages}
      ctaTitleKey="servicePages.surgery.ctaTitle"
      ctaDescriptionKey="servicePages.surgery.ctaDescription"
      ctaButtonKey="servicePages.surgery.ctaButton"
    />
  );
}